import DashEmptyState from './DashEmptyState.component';

export default DashEmptyState;